import { createFileRoute } from "@tanstack/react-router";
import { EmpowerAlternativesComponent } from "@/pages/compare-empower-alternatives";
import { head, loader } from "@/pages/compare-empower-alternatives.meta";

export const Route = createFileRoute("/$locale/compare/empower-alternatives")({
  loader,
  head,
  component: function CompareEmpowerAlternativesComponentRoute() {
    const { faqs, offersAsOf } = Route.useLoaderData();
    return <EmpowerAlternativesComponent faqs={faqs} offersAsOf={offersAsOf} />;
  },
});
